import React from 'react';
import * as PropTypes from 'prop-types';
import Button from "../../common/Button";
import {ButtonTypes} from "../../../constants/Enums";
import {h4Styles, pStyles} from "./ContentSection.css";

const ContentSection = (props) => {
  return (
    <div className={"col-md-4"} style={{marginBottom:'1.5rem'}}>
      <h4 style={h4Styles}>{props.title}</h4>
      <p style={pStyles}>
        {props.text}
      </p>
      <Button text={props.buttonText} type={ButtonTypes.SECONDARY} action={() => window.open(props.buttonLinkDestination)}/>
    </div>
  );
};

ContentSection.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonLinkDestination: PropTypes.string.isRequired
};

export default ContentSection;